



























































import Vue from "vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { RootState } from "@/store";

import { UpdateCurrentUserCommand } from "@/model/communication/auth/UpdateCurrentUserCommand";
import { UpdateCurrentUserReqData } from "@/model/communication/auth/UpdateCurrentUserReqData";
import { GetAvailableLanguagesCommand } from "@/model/communication/application/GetAvailableLanguagesCommand";

import ChangePasswordCard from "@/views/App/Components/ChangePasswordCard.vue";
import { GET_CURRENT_USER } from "@/store/modules/AuthenticationModule/actions";
import { UserConfig } from "@/model/data/authentication/UserConfig";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ADD_ALERT } from "@/store/modules/AlertModule/mutations";
import { timezonesIT, timezonesUS, timezonesDE, timezonesES } from "@/utility/TimeZones";

export default Vue.extend({
    components: {
        ChangePasswordCard,
    },
    data() {
        return {
            loading: false,
            changePasswordDialog: false,
            newMail: "",
            currentUserConfig: new UserConfig(),
            availableLanguageOptions: [],
        };
    },
    computed: {
        ...mapState({
            currentUser: (state: RootState) => state.authMod.currentUser,
        }),
        ...mapGetters(["localeFromOptions"]),
        changed() {
            return JSON.stringify(this.currentUserConfig) != JSON.stringify(this.currentUser.userConfig) || this.newMail != this.currentUser.email;
        },
        availableTimeFormat() {
            return [
                {
                    text: `AM/PM (${this.$t("options.forExample")} 2:52 PM)`,
                    value: "ampm",
                },
                {
                    text: `24 ${this.$t("options.hours")} (${this.$t("options.forExample")} 14:52)`,
                    value: "24hr",
                },
            ];
        },
        availableDateFormat() {
            return [
                {
                    text: `${this.$t("options.day")}-${this.$t("options.month")}-${this.$t("options.year")} (${this.$t("options.forExample")} 31-12-2022)`,
                    value: "DD-MM-YYYY",
                },
                {
                    text: `${this.$t("options.year")}-${this.$t("options.month")}-${this.$t("options.day")} (${this.$t("options.forExample")} 2022-12-31)`,
                    value: "YYYY-MM-DD",
                },
                {
                    text: `${this.$t("options.month")}-${this.$t("options.day")}-${this.$t("options.year")} (${this.$t("options.forExample")} 12-31-2022)`,
                    value: "MM-DD-YYYY",
                },
            ];
        },
        availableTimeZones() {
            let timezones = timezonesUS;
            if (this.currentUserConfig && this.currentUserConfig.language && this.currentUserConfig.language == "it") timezones = timezonesIT;
            if (this.currentUserConfig && this.currentUserConfig.language && this.currentUserConfig.language == "de") timezones = timezonesDE;
            if (this.currentUserConfig && this.currentUserConfig.language && this.currentUserConfig.language == "es") timezones = timezonesES;
            let sortedTimezones = [];
            timezones.forEach((timezone) => {
                sortedTimezones.push({ text: timezone.text, value: timezone.value, selected: this.currentUserConfig.timezone == timezone.value ? 1 : 0 });
            });
            sortedTimezones.sort((a: any, b: any) => {
                return b.selected - a.selected || a.value - b.value;
            });
            return sortedTimezones;
        },
    },
    watch: {
        currentUser: {
            deep: true,
            handler() {
                this.currentUserConfig.language = this.currentUser.userConfig.language;
                this.currentUserConfig.dateFormat = this.currentUser.userConfig.dateFormat;
                this.currentUserConfig.timeFormat = this.currentUser.userConfig.timeFormat;
                this.currentUserConfig.timezone = this.currentUser.userConfig.timezone;
                this.currentUserConfig.theme = this.currentUser.userConfig.theme;
                this.currentUserConfig.lockedMenu = this.currentUser.userConfig.lockedMenu;
                this.newMail = this.currentUser.email;
            },
        },
    },
    methods: {
        ...mapMutations([ADD_ALERT]),
        ...mapActions([GET_CURRENT_USER]),
        async save() {
            let reqData = new UpdateCurrentUserReqData();

            reqData.email = this.newMail;
            reqData.userConfig = this.currentUserConfig;
            this.loading = true;
            await new UpdateCurrentUserCommand(reqData).execute();
            await this[GET_CURRENT_USER]();
            this.loading = false;
        },
        async fetchAvailableLanguages() {
            let res = await new GetAvailableLanguagesCommand().execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                this.availableLanguageOptions.splice(0, this.availableLanguageOptions.length, ...res.availableLanguages);
            }
        },
    },
    mounted() {
        if (this.currentUser) {
            this.newMail = this.currentUser.email;
            this.currentUserConfig.dateFormat = this.currentUser.userConfig.dateFormat;
            this.currentUserConfig.timeFormat = this.currentUser.userConfig.timeFormat;
            this.currentUserConfig.lockedMenu = this.currentUser.userConfig.lockedMenu;
            this.currentUserConfig.timezone = this.currentUser.userConfig.timezone;
            this.currentUserConfig.theme = this.currentUser.userConfig.theme;
            if (
                this.currentUser.userConfig != null &&
                (this.currentUser.userConfig.language == null || this.currentUser.userConfig.language == undefined || this.currentUser.userConfig.language.trim() == "")
            ) {
                if (this.localeFromOptions != null) this.currentUser.userConfig.language = this.localeFromOptions;
                else this.currentUser.userConfig.language = "en";
            }
            this.currentUserConfig.language = this.currentUser.userConfig.language;
        }

        this.fetchAvailableLanguages();
    },
});
